import { Pipe, PipeTransform } from '@angular/core';
import { FindOneFile } from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BucketService } from '../services';

@Pipe({
  name: 'fileUrl',
  standalone: false,
})
export class FileUrlPipe implements PipeTransform {
  constructor(private bucketService: BucketService) {}

  transform(
    url?: string | null,
    query: FindOneFile = {}
  ): Observable<string | null> {
    if (!url || typeof url !== 'string') return of(null);

    const regExp = new RegExp('https?:/{2}\\S+');
    if (regExp.test(url)) {
      return of(url);
    }
    return this.bucketService
      .fetchFileUrl(url, ObjectUtil.removeEmptyProperties(query))
      .pipe(map(({ url }) => url));
  }
}
